export default __webpack_public_path__ + "static/media/flash-sale-bg.6ac9ed05.jpg";